import { useCallback, useEffect, useState } from "react";
import { api } from "@/lib/api";

export const usd = (pb) => {
  if (!pb) return "—";
  const v = pb.amount_minor / 100;
  return `$${v.toLocaleString("en-US", { minimumFractionDigits: v % 1 ? 2 : 0 })}`;
};
export const inr = (pb) => (pb ? `₹${(pb.amount_minor / 100).toLocaleString("en-IN")}` : "—");

export const downloadReport = async (evaluationId) => {
  const r = await api.get(`/evaluations/${evaluationId}/report.pdf`, { responseType: "blob" });
  const url = URL.createObjectURL(r.data);
  const a = document.createElement("a");
  a.href = url;
  a.download = `IdeaValidator360-report-${evaluationId}.pdf`;
  a.click();
  setTimeout(() => URL.revokeObjectURL(url), 2000);
};

// Purchases for ONE evaluation; never exposes data that belongs to a previous selection.
export const usePurchases = (evaluationId) => {
  const [p, setP] = useState(null);
  const load = useCallback(() => {
    if (!evaluationId) return;
    api.get(`/evaluations/${evaluationId}/purchases`).then((r) => setP({ ...r.data, forId: evaluationId })).catch(() => null);
  }, [evaluationId]);
  useEffect(() => { setP(null); load(); }, [load]);
  return p?.forId === evaluationId ? p : null;
};
